/**
 * Adopted PDP / textbook quick-add "Item In Bag" badge.
 * Same placement as CMRP (purchase-type-meta, hide Smart Pick).
 * Not used on merchandising (non-adopted) PDPs.
 */
(function () {
  const IN_BAG_HTML =
    '<span class="in-bag-indicator" style="display: none;" aria-hidden="true">' +
    '<span class="in-bag-text">Item In Bag</span>' +
    '</span>';

  const OPTION_SELECTOR =
    '.product-information--adopted .accordion-variant-option[data-variant-id], ' +
    '.textbook-variant-picker .accordion-variant-option[data-variant-id], ' +
    '#quick-add-modal-content .accordion-variant-option[data-variant-id]';

  function getOptionRoot(root) {
    if (root && root.querySelectorAll) return root;
    return document;
  }

  function getVariantId(el) {
    if (!el) return null;
    const own = el.getAttribute && el.getAttribute('data-variant-id');
    if (own) return own;
    const nested = el.querySelector && el.querySelector('[data-variant-id]');
    return nested ? nested.getAttribute('data-variant-id') : null;
  }

  function collectTargets(root) {
    return Array.from(getOptionRoot(root).querySelectorAll(OPTION_SELECTOR));
  }

  function ensurePurchaseTypeMeta(optionEl) {
    let meta = optionEl.querySelector('.purchase-type-meta');
    if (meta) return meta;

    meta = document.createElement('div');
    meta.className = 'purchase-type-meta';

    const rentalDue = optionEl.querySelector('.accordion-variant-rental-due');
    if (rentalDue && !rentalDue.closest('.purchase-type-meta')) {
      rentalDue.replaceWith(meta);
      meta.appendChild(rentalDue);
      return meta;
    }

    meta.classList.add('purchase-type-meta--badge-only');
    const fee = optionEl.querySelector(':scope > .purchase-type-digital-fee');
    const label = optionEl.querySelector('.accordion-variant-option-label');
    if (fee) {
      optionEl.insertBefore(meta, fee);
    } else if (label) {
      label.appendChild(meta);
    } else {
      optionEl.appendChild(meta);
    }
    return meta;
  }

  function createBadge() {
    const wrap = document.createElement('div');
    wrap.innerHTML = IN_BAG_HTML;
    return wrap.firstElementChild;
  }

  function normalizeBadge(badge) {
    if (!badge) return null;
    const text = badge.querySelector('.in-bag-text');
    if (text) text.textContent = 'Item In Bag';
    badge.querySelectorAll('svg').forEach((svg) => svg.remove());
    return badge;
  }

  function getOrCreateAccordionBadge(optionEl) {
    let badge = normalizeBadge(optionEl.querySelector('.in-bag-indicator')) || createBadge();
    if (!badge) return null;
    const meta = ensurePurchaseTypeMeta(optionEl);
    if (!badge.closest('.purchase-type-meta')) {
      meta.appendChild(badge);
    }
    return badge;
  }

  function hideBadge(el) {
    const badge = el.querySelector('.in-bag-indicator');
    if (badge) {
      badge.style.display = 'none';
      badge.setAttribute('aria-hidden', 'true');
    }
  }

  function showBadge(badge) {
    if (!badge) return;
    badge.style.display = 'inline-flex';
    badge.setAttribute('aria-hidden', 'false');
  }

  function setOptionInBag(optionEl, inCart) {
    optionEl.classList.toggle('in-cart', inCart);

    const smartPickBadge = optionEl.querySelector('.smart-pick-badge');
    if (smartPickBadge) {
      smartPickBadge.style.display = inCart ? 'none' : '';
    }

    if (!inCart) {
      hideBadge(optionEl);
      return;
    }
    showBadge(getOrCreateAccordionBadge(optionEl));
  }

  async function updatePdpInBagIndicators(root) {
    const cartChecker = window.cartChecker;
    if (!cartChecker) return;

    const options = collectTargets(root);
    if (!options.length) return;

    const variantIds = options.map(getVariantId).filter(Boolean);
    if (!variantIds.length) return;

    try {
      const inCartResults = await cartChecker.checkMultipleVariants(variantIds);
      options.forEach((optionEl) => {
        const variantId = getVariantId(optionEl);
        const inCart = Boolean(variantId && inCartResults[variantId]);
        setOptionInBag(optionEl, inCart);
      });
    } catch (error) {
      /* ignore — badge is non-critical */
    }
  }

  let cartListenerBound = false;
  function bindCartListeners() {
    if (cartListenerBound || window.__pdpInBagListenersBound) return;
    cartListenerBound = true;
    window.__pdpInBagListenersBound = true;
    const refresh = () => {
      queueMicrotask(() => {
        updatePdpInBagIndicators(document);
      });
    };
    ['cart:add', 'cart:update', 'cart:change', 'variant:update'].forEach((event) => {
      document.addEventListener(event, refresh);
    });
  }

  function initPdpInBagIndicators() {
    bindCartListeners();
    updatePdpInBagIndicators(document);
  }

  window.updatePdpInBagIndicators = updatePdpInBagIndicators;
  window.initPdpInBagIndicators = initPdpInBagIndicators;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPdpInBagIndicators);
  } else {
    initPdpInBagIndicators();
  }
})();
